var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { AddExpenses } from "../AddExpenses";
import { Row } from "react-bootstrap";
import GenericSidebar from "../../../../shared-library/components/GenericSidebar";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
export var Newproduct = function (props) {
    var device = DeviceContext();
    var _a = __read(React.useState(false), 2), openDetails = _a[0], setOpendetails = _a[1];
    return (React.createElement("div", { className: "newproducts-icon-block mgt-15" },
        React.createElement("div", { className: "DMSans_16_500 txt-midnight-blue displayFlex" },
            React.createElement("i", { className: "edel-icon-product-info" }),
            React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: props.newBtnTitle ? props.newBtnTitle : "New Product", type: "button", className: "mgl-7", onClick: function () { return props.createNewProduct(); } })),
        props.pitchicon && false ? (React.createElement("div", { className: "DMSans_16_500 txt-midnight-blue displayFlex" },
            React.createElement("i", { className: "edel-icon-product-pitch" }),
            React.createElement("span", { className: "sales-button-M16" },
                React.createElement(EdButton, { btnTyp: "midnight-blue-underline", type: "button", value: "Product Pitch", className: "mgl-7", onClick: function () { return props.pitchicon(); } })))) : (""),
        (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(GenericSidebar, { parentClassname: "profile-expenses-block profile-overview-block", header: React.createElement(Row, { className: "m-0" },
                React.createElement("span", { className: "txt_blackOne1 leadlog-headspan DMSans_16_500" }, "Add Expenses")), body: React.createElement("div", { className: "DMSanN_16_400 txt_blackOne1 content-body" },
                React.createElement(AddExpenses, null)), footer: React.createElement(React.Fragment, null,
                React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Submit", type: "button", onClick: function () { return setOpendetails(false); } })), openKey: openDetails, arrowClose: true, setOpenKey: setOpendetails, delay: 10 })) : ("")));
};
